export const isTerminal = process.env.REACT_APP_BUILD_TERMINAL;
export const iframeProxyEpassport = process.env.REACT_APP_IFRAME_PROXY_EPASSPORT;
export const CLAIMS = {
    LOCAL_TRIP: "localtrip_availability_group",
    LINE_MANAGER: "line_manager_group",
    HAS_DOCUMENTS: "documents_sign_only_group",
};
